import { Accordion } from './accordion.tsx'
const accordionItems = [
  {
    trigger: (
      <p className="font-semibold text-foreground-muted md:text-nowrap">
        ¿Cómo funciona la reserva?
      </p>
    ),
    content: (
      <p className="text-foreground-muted">
        Selecciona el día y la hora que mejor te encaje del calendario del
        profesional. Asegúrate de que la zona horaria corresponde a la tuya.
        Regístrate, realiza el pago y ¡listo! Una vez confirmada tu reserva,
        recibirás un correo con todos los detalles de la sesión. También podrás
        consultarlos en tu perfil, en el apartado “Próximas sesiones”.
      </p>
    ),
  },
  {
    trigger: (
      <p className="font-semibold text-foreground-muted md:text-nowrap">
        ¿Cómo se realizan las sesiones?
      </p>
    ),
    content: (
      <p className="text-foreground-muted">
        Las sesiones pueden realizarse por videollamada, audio, escrito o vídeo,
        según la opción que elijas al hacer la reserva.{' '}
        <strong>Si la sesión es por videollamada</strong>, te llegará el enlace
        para conectarte a tu correo. También podrás acceder directamente a
        través de tu perfil de Miistico en el apartado “Próximas sesiones”.{' '}
        <strong>
          No es necesario descargarse ninguna aplicación. Si la sesión es en
          formato audio, escrito o vídeo,
        </strong>{' '}
        recibirás un correo electrónico con tu lectura. También estará
        disponible en la plataforma, en el apartado “Mis compras”.
      </p>
    ),
  },
  {
    trigger: (
      <p className="font-semibold text-foreground-muted md:text-nowrap">
        ¿Cómo se realiza el pago?
      </p>
    ),
    content: (
      <p className="text-foreground-muted">
        El pago se efectúa al momento de realizar la reserva, de forma segura, a
        través de nuestra plataforma. Puedes pagar con tarjeta bancaria, Google
        Pay, Apple Pay o PayPal.
      </p>
    ),
  },
  {
    trigger: (
      <p className="font-semibold text-foreground-muted md:text-nowrap">
        ¿Puedo cambiar o cancelar la cita que he reservado?
      </p>
    ),
    content: (
      <p className="text-foreground-muted">
        Sí, puedes cambiar o cancelar tu cita de forma gratuita con al menos 24
        horas de antelación. Para hacerlo, ve al apartado “Próximas sesiones” de
        tu perfil y haz clic en “Cancelar” o “Reprogramar”.
      </p>
    ),
  },
  {
    trigger: (
      <p className="font-semibold text-foreground-muted md:text-nowrap">
        ¿Qué pasa si no asisto a la sesión?
      </p>
    ),
    content: (
      <p className="text-foreground-muted">
        Si no te presentas a la sesión sin haberla cancelado o reprogramado con
        al menos 24 horas de antelación, lamentablemente no podremos realizar el
        reembolso, ya que el tiempo del profesional ya estaba reservado para ti.
        Te recomendamos avisar con la mayor antelación posible si surge algún
        imprevisto, para poder ayudarte y reprogramar tu cita si es necesario.
      </p>
    ),
  },
]

export default function FAQ() {
  return <Accordion variant="faq" accordionItems={accordionItems} />
}
